// extracted by mini-css-extract-plugin
export default {"numericInput":"ClonePlaceholderForm-module__numericInput___sQBWy","checkbox":"ClonePlaceholderForm-module__checkbox___fGoGW"};